import { render, staticRenderFns } from "./CytologySpecimenView.vue?vue&type=template&id=6ce56617&scoped=true&"
import script from "./CytologySpecimenView.vue?vue&type=script&lang=js&"
export * from "./CytologySpecimenView.vue?vue&type=script&lang=js&"
import style0 from "./CytologySpecimenView.vue?vue&type=style&index=0&id=6ce56617&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ce56617",
  null
  
)

export default component.exports